import { render, staticRenderFns } from "./SelectedItemContent.vue?vue&type=template&id=09a2b4ba&lang=pug&"
import script from "./SelectedItemContent.vue?vue&type=script&lang=js&"
export * from "./SelectedItemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports